// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/1ea05ed82c1af42eccdb.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8546f56395a809f84ab3","137":"c9f0ea2dc34dac5ed426","138":"f51b01628addf2924412"}[chunkId] + ".chunk.js";
};